import { render, staticRenderFns } from "./RouteInfoDetailedStatus.vue?vue&type=template&id=3896db23&"
import script from "./RouteInfoDetailedStatus.vue?vue&type=script&lang=js&"
export * from "./RouteInfoDetailedStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports